import React, { useState, useEffect } from "react";

export default function NumberInput({
  label,
  value,
  min,
  max,
  step = 1,
  onChange,
  onBlur,
}) {
  const [localValue, setLocalValue] = useState(value);

  useEffect(() => {
    // Only update localValue if the numerical value has changed
    // This allows typing decimals like "1." without the dot being stripped
    if (value !== Number(localValue)) {
      setLocalValue(value);
    }
  }, [value]);

  return (
    <label className="ctrl">
      <span>{label}</span>
      <input
        type="number"
        min={min}
        max={max}
        step={step}
        value={
          localValue === 0 &&
          (value === 0 || value === undefined) &&
          localValue !== ""
            ? 0
            : localValue
        }
        onChange={(e) => {
          const val = e.target.value;
          setLocalValue(val);
          if (val !== "") {
            onChange(Number(val));
          }
        }}
        onBlur={(e) => {
          let val = Number(localValue);
          if (
            localValue === "" ||
            localValue === undefined ||
            localValue === null
          ) {
            val = min !== undefined ? min : 0;
          } else {
            if (min !== undefined && val < min) val = min;
            if (max !== undefined && val > max) val = max;
          }
          setLocalValue(val);
          onChange(val);
          if (onBlur) onBlur(e);
        }}
      />
    </label>
  );
}
